import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../hooks/useSEO';

const ServiceAreaPage = () => {
  const [selectedArea, setSelectedArea] = useState('台北市');

  useSEO({
    title: '服務區域 - 建鈞精緻搬家｜新北桃園新竹台北搬家服務範圍',
    description: '建鈞搬家服務範圍涵蓋新北市、台北市、桃園市、新竹市、基隆市、台中市、台南市、高雄市、彰化縣等地區。24小時搬家服務，專業團隊，立即預約0978-900-081。',
    keywords: '搬家服務範圍,新北搬家,台北搬家,桃園搬家,新竹搬家,服務區域',
    ogType: 'website'
  });

  const serviceAreas = [
    {
      name: '台北市',
      city: '台北市',
      link: '/area/taipei',
      description: '都會區精緻搬家服務',
      features: ['捷運沿線便利', '商業區專業', '高樓搬遷經驗'],
      color: 'blue',
      icon: 'ri-building-line',
      districts: ['中正區', '大同區', '中山區', '松山區', '大安區', '萬華區', '信義區', '士林區', '北投區', '內湖區', '南港區', '文山區']
    },
    {
      name: '新北市',
      city: '新北市',
      link: '/area/new-taipei',
      description: '29區完整覆蓋服務',
      features: ['住宅社區專業', '跨區搬遷', '在地深耕'],
      color: 'emerald',
      icon: 'ri-community-line',
      districts: ['板橋區', '新莊區', '中和區', '永和區', '土城區', '三重區', '蘆洲區', '汐止區', '新店區', '淡水區', '林口區', '三峽區', '樹林區', '鶯歌區', '泰山區', '五股區', '八里區', '萬里區', '金山區', '瑞芳區', '平溪區', '雙溪區', '貢寮區', '石門區', '石碇區', '深坑區', '烏來區']
    },
    {
      name: '桃園市',
      city: '桃園市',
      link: '/area/taoyuan',
      description: '機場城市廢棄物清運',
      features: ['工業區搬遷', '廢棄物處理', '裝潢廢料'],
      color: 'orange',
      icon: 'ri-plane-line',
      districts: ['桃園區', '中壢區', '平鎮區', '八德區', '楊梅區', '蘆竹區', '龜山區', '龍潭區', '大溪區', '大園區', '新屋區', '觀音區', '復興區']
    },
    {
      name: '新竹市縣',
      city: '新竹市縣',
      link: '/area/hsinchu',
      description: '科技園區精密搬遷',
      features: ['精密設備', '實驗室搬遷', '科技認證'],
      color: 'purple',
      icon: 'ri-computer-line',
      districts: ['東區', '北區', '香山區', '竹北市', '竹東鎮', '新埔鎮', '關西鎮', '湖口鄉', '新豐鄉', '芎林鄉', '橫山鄉', '北埔鄉', '寶山鄉', '峨眉鄉']
    },
    {
      name: '台中市',
      city: '台中市',
      link: '/area/taichung',
      description: '中部地區專業搬遷',
      features: ['學生宿舍', '透天厝搬家', '中科園區'],
      color: 'green',
      icon: 'ri-home-smile-line',
      districts: ['中區', '東區', '南區', '西區', '北區', '西屯區', '南屯區', '北屯區', '豐原區', '東勢區', '大甲區', '清水區', '沙鹿區', '梧棲區', '后里區', '神岡區', '潭子區', '大雅區', '新社區', '石岡區', '外埔區', '大安區', '烏日區', '大肚區', '龍井區', '霧峰區', '太平區', '大里區', '和平區']
    },
    {
      name: '台南市',
      city: '台南市',
      link: '/area/tainan',
      description: '古都文化資產搬遷',
      features: ['古董文物', '老屋翻新', '傳統建築'],
      color: 'amber',
      icon: 'ri-building-2-line',
      districts: ['中西區', '東區', '南區', '北區', '安平區', '安南區', '永康區', '歸仁區', '新化區', '左鎮區', '玉井區', '楠西區', '南化區', '仁德區', '關廟區', '龍崎區', '官田區', '麻豆區', '佳里區', '西港區', '七股區', '將軍區', '學甲區', '北門區', '新營區', '後壁區', '白河區', '東山區', '六甲區', '下營區', '柳營區', '鹽水區', '善化區', '大內區', '山上區', '新市區', '安定區']
    },
    {
      name: '高雄市',
      city: '高雄市',
      link: '/area/kaohsiung',
      description: '港都工業搬遷專家',
      features: ['港區倉儲', '重工業設備', '捷運沿線'],
      color: 'cyan',
      icon: 'ri-ship-line',
      districts: ['新興區', '前金區', '苓雅區', '鹽埕區', '鼓山區', '旗津區', '前鎮區', '三民區', '楠梓區', '小港區', '左營區', '仁武區', '大社區', '岡山區', '路竹區', '阿蓮區', '田寮區', '燕巢區', '橋頭區', '梓官區', '彌陀區', '永安區', '湖內區', '鳳山區', '大寮區', '林園區', '鳥松區', '大樹區', '旗山區', '美濃區', '六龜區', '內門區', '杉林區', '甲仙區', '桃源區', '那瑪夏區', '茂林區', '茄萣區']
    },
    {
      name: '彰化縣',
      city: '彰化縣',
      link: '/area/changhua',
      description: '精密機械產業搬遷',
      features: ['精密設備', '工廠整廠', '農業機具'],
      color: 'lime',
      icon: 'ri-tools-line',
      districts: ['彰化市', '芬園鄉', '花壇鄉', '秀水鄉', '鹿港鎮', '福興鄉', '線西鄉', '和美鎮', '伸港鄉', '員林市', '社頭鄉', '永靖鄉', '埔心鄉', '溪湖鎮', '大村鄉', '埔鹽鄉', '田中鎮', '北斗鎮', '田尾鄉', '埤頭鄉', '溪州鄉', '竹塘鄉', '二林鎮', '大城鄉', '芳苑鄉', '二水鄉']
    },
    {
      name: '基隆市',
      city: '基隆市',
      link: '/area/keelung',
      description: '港都山城搬遷專家',
      features: ['港口物流', '山坡地形', '老舊建築'],
      color: 'slate',
      icon: 'ri-mountain-line',
      districts: ['仁愛區', '信義區', '中正區', '中山區', '安樂區', '暖暖區', '七堵區']
    }
  ];

  // 根據選中的區域找到對應的資料
  const selectedAreaData = serviceAreas.find(area => area.city === selectedArea);

  return (
    <div className="min-h-screen bg-white">
      {/* Header with Navigation - 與首頁相同的樣式 */}
      <header className="relative">
        <nav className="hidden lg:flex absolute top-8 right-8 gap-6 text-sm font-medium z-10">
          <Link 
            to="/"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-home-4-line text-base group-hover:scale-110 transition-transform"></i>
            <span>首頁</span>
          </Link>
          <Link 
            to="/about"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-information-line text-base group-hover:scale-110 transition-transform"></i>
            <span>關於我們</span>
          </Link>
          <Link 
            to="/services"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-service-line text-base group-hover:scale-110 transition-transform"></i>
            <span>服務項目</span>
          </Link>
          <Link 
            to="/service-area"
            className="text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group font-semibold"
          >
            <i className="ri-map-pin-line text-base group-hover:scale-110 transition-transform"></i>
            <span>服務範圍</span>
          </Link>
          <Link 
            to="/pricing"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-calculator-line text-base group-hover:scale-110 transition-transform"></i>
            <span>搬家費用</span>
          </Link>
          <Link 
            to="/cases"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-gallery-line text-base group-hover:scale-110 transition-transform"></i>
            <span>成功案例</span>
          </Link>
          <Link 
            to="/knowledge"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-book-open-line text-base group-hover:scale-110 transition-transform"></i>
            <span>搬家知識</span>
          </Link>
          <Link 
            to="/faq"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-question-line text-base group-hover:scale-110 transition-transform"></i>
            <span>常見問題</span>
          </Link>
          <Link 
            to="/contact"
            className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
          >
            <i className="ri-customer-service-line text-base group-hover:scale-110 transition-transform"></i>
            <span>聯絡我們</span>
          </Link>
        </nav>
      </header>

      <main>
        {/* Hero Section */}
        <section 
          className="relative py-24 bg-gradient-to-b from-teal-50 to-white"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
              建鈞精緻搬家 服務範圍
            </h1>
            <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed mb-4">
              台北｜新北｜桃園｜新竹｜台中｜台南｜高雄｜彰化｜基隆 全區域服務
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              無論您在哪裡，我們都能快速到達
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:0978900081"
                className="bg-teal-600 text-white px-8 py-4 rounded-full text-xl font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-3 shadow-lg"
              >
                <i className="ri-phone-line text-2xl"></i>
                立即致電：0978900081
              </a>
              <a 
                href="https://line.me/ti/p/~sarahst018"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-white px-8 py-4 rounded-full text-xl font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-3 shadow-lg"
              >
                <i className="ri-line-fill text-2xl"></i>
                LINE 線上諮詢
              </a>
            </div>
          </div>
        </section>

        {/* 快速選擇區域 */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">我們服務這些地區</h2>
              <p className="text-xl text-gray-600">點擊查看詳細服務區域</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {serviceAreas.map((area) => (
                <button
                  key={area.city}
                  onClick={() => setSelectedArea(area.city)}
                  className={`p-6 rounded-2xl transition-all duration-300 cursor-pointer text-left transform hover:scale-105 ${
                    selectedArea === area.city
                      ? 'bg-teal-600 text-white shadow-2xl scale-105'
                      : 'bg-white text-gray-700 hover:bg-gray-50 shadow-lg hover:shadow-xl'
                  }`}
                >
                  <div className="flex items-center gap-4 mb-3">
                    <div className={`w-16 h-16 rounded-full flex items-center justify-center ${
                      selectedArea === area.city 
                        ? 'bg-white/20' 
                        : 'bg-teal-100'
                    }`}>
                      <i className={`${area.icon} text-3xl ${
                        selectedArea === area.city 
                          ? 'text-white' 
                          : 'text-teal-600'
                      }`}></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold">{area.city}</h3>
                      <p className={`text-base ${
                        selectedArea === area.city 
                          ? 'text-white/80' 
                          : 'text-gray-500'
                      }`}>
                        {area.description}
                      </p>
                    </div>
                  </div>
                  <div className="text-right mt-4">
                    <span className={`text-base font-medium ${
                      selectedArea === area.city 
                        ? 'text-white/80' 
                        : 'text-teal-600'
                    }`}>
                      服務 {area.districts.length} 個區域
                    </span>
                  </div>
                </button>
              ))}
            </div>

            {/* 選中地區的詳細資訊 */}
            {selectedAreaData && (
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-teal-600 to-teal-700 p-8 text-white text-center">
                  <div className="flex items-center justify-center gap-4 mb-4">
                    <i className={`${selectedAreaData.icon} text-5xl`}></i>
                    <h3 className="text-4xl font-bold">{selectedAreaData.city}</h3>
                  </div>
                  <p className="text-2xl text-teal-100">{selectedAreaData.description}</p>
                </div>

                <div className="p-8">
                  {/* 服務特色 */}
                  <div className="mb-8">
                    <h4 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                      <i className="ri-star-line text-yellow-500 text-2xl"></i>
                      這個地區我們提供
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {selectedAreaData.features.map((feature, index) => (
                        <div 
                          key={index} 
                          className="flex items-center gap-3 p-4 bg-teal-50 rounded-xl hover:bg-teal-100 transition-colors"
                        >
                          <i className="ri-checkbox-circle-fill text-teal-600 text-2xl"></i>
                          <span className="font-medium text-gray-800 text-lg">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* 服務區域 */}
                  <div>
                    <h4 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                      <i className="ri-map-pin-2-line text-green-500 text-2xl"></i>
                      具體服務區域（共 {selectedAreaData.districts.length} 個）
                    </h4>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      {selectedAreaData.districts.map((district, index) => (
                        <div 
                          key={index} 
                          className="bg-gray-50 rounded-xl p-4 text-center hover:bg-teal-50 hover:shadow-md transition-all cursor-pointer group"
                        >
                          <div className="flex items-center justify-center gap-2">
                            <i className="ri-map-pin-fill text-teal-500 text-xl group-hover:text-teal-600"></i>
                            <span className="font-medium text-gray-800 group-hover:text-teal-700 text-base">{district}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* CTA 區域 */}
                  <div className="mt-12 text-center">
                    <div className="bg-gradient-to-r from-teal-50 to-green-50 rounded-3xl p-8">
                      <h4 className="text-2xl font-bold text-gray-900 mb-4">
                        需要在 {selectedAreaData.city} 搬家嗎？
                      </h4>
                      <p className="text-lg text-gray-600 mb-6">
                        立即聯繫我們，獲得專業搬家服務諮詢
                      </p>
                      <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a 
                          href="tel:0978900081"
                          className="bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
                        >
                          <i className="ri-phone-line"></i>
                          立即致電
                        </a>
                        <Link 
                          to={selectedAreaData.link}
                          className="bg-gray-700 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
                        >
                          <i className="ri-arrow-right-line"></i>
                          查看詳細頁面
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* 服務承諾 */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">我們的服務承諾</h2>
              <p className="text-xl text-gray-600">無論您在哪個地區，都能享受相同的專業服務品質</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center group">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-200 transition-colors">
                  <i className="ri-time-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">快速到達</h3>
                <p className="text-gray-600">各地區均有服務據點，30分鐘內快速到達現場評估</p>
              </div>

              <div className="text-center group">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-emerald-200 transition-colors">
                  <i className="ri-shield-check-line text-4xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">品質保證</h3>
                <p className="text-gray-600">統一的服務標準，專業團隊訓練，確保搬家品質一致</p>
              </div>

              <div className="text-center group">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-200 transition-colors">
                  <i className="ri-map-pin-user-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">在地熟悉</h3>
                <p className="text-gray-600">熟悉各地區交通路線與建築特色，提供最適合的搬家方案</p>
              </div>

              <div className="text-center group">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-emerald-200 transition-colors">
                  <i className="ri-customer-service-2-line text-4xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">全程服務</h3>
                <p className="text-gray-600">從諮詢到完成，專人全程跟進，確保搬家過程順利</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-teal-400">建鈞精緻搬家</h3>
              <p className="text-gray-300 mb-4">專業搬家團隊，讓您的搬家過程輕鬆無憂</p>
              <div className="flex gap-4">
                <a href="tel:0978900081" className="text-teal-400 hover:text-white transition-colors">
                  <i className="ri-phone-line text-xl"></i>
                </a>
                <a href="https://line.me/ti/p/~sarahst018" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-white transition-colors">
                  <i className="ri-line-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">服務項目</h4>
              <ul className="space-y-2 text-gray-300">
                <li><Link to="/services" className="hover:text-white transition-colors">套房搬家</Link></li>
                <li><Link to="/services" className="hover:text-white transition-colors">家庭搬遷</Link></li>
                <li><Link to="/services" className="hover:text-white transition-colors">辦公室搬遷</Link></li>
                <li><Link to="/services" className="hover:text-white transition-colors">廢棄物處理</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">服務地區</h4>
              <ul className="space-y-2 text-gray-300">
                <li><Link to="/area/taipei" className="hover:text-white transition-colors">台北市</Link></li>
                <li><Link to="/area/new-taipei" className="hover:text-white transition-colors">新北市</Link></li>
                <li><Link to="/area/taoyuan" className="hover:text-white transition-colors">桃園市</Link></li>
                <li><Link to="/area/hsinchu" className="hover:text-white transition-colors">新竹市縣</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-center gap-3">
                  <i className="ri-phone-line text-teal-400"></i>
                  <a href="tel:0978900081" className="hover:text-white transition-colors">0978-900-081</a>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-line-fill text-teal-400"></i>
                  <a href="https://line.me/ti/p/~sarahst018" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">LINE: sarahst018</a>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-map-pin-line text-teal-400"></i>
                  <span>新北市及周邊地區</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 建鈞精緻搬家. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-white transition-colors ml-2">Web Design</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServiceAreaPage;
